import { Box, Spacer } from '@jfs/ui-new'
import { SubTitle } from '../../../comps/SubTitle'
import { Title } from '../../../comps/Title'
import { getDDMMMYYDateFromYYYMMDD, getFormattedAmount } from '../../../util/utill'
import { StatusText } from '../../TransactionEnquiryScreen/StatusText'

interface TransactionListItemProps {
  onPress: (data: any) => void
  data: any
}

export const TransactionListItem = ({ data, onPress }: TransactionListItemProps) => {
  const subTitle =
    (data?.rrn ? `RRN No: ${data?.rrn}  | ` : '') +
    (data?.invoice ? `Invoice No: ${data?.invoice}` : '') +
    (data?.payerMobileNo ? ` | Payer MobileNo: ${data?.payerMobileNo}` : '') +
    (data?.bankIfsc ? ` | Bank IFSC: ${data?.bankIfsc} (${data.beneBankName})` : '')+(data?.remFirstName && data?.remLastName ? ` | Customer Name: ${data?.remFirstName} ${data?.remLastName}` : '')

  return (
    <Box
      flexDirection={'row'}
      borderBottomWidth={1}
      borderColor="GRAY_BORDER"
      height={'100%'}
      underlayColor="GRAY_LIGHT"
      onPress={() => {
        onPress(data)
      }}
      paddingHorizontal={16}
      justifyContent="space-between"
      alignItems={'center'}
      alignContent="center">
      <Box flexDirection={'column'} alignItems={'flex-start'} flex={1}>
        <Title title={getDDMMMYYDateFromYYYMMDD(data?.businessDate)} />
        <Spacer direction="vertical" size={6} />
        <SubTitle subTitle={subTitle} textAlign="left" />
      </Box>

      <Box flexDirection={'column'} alignItems={'flex-end'}>
        <Title title={getFormattedAmount(+(data?.grossAmount || '0'))} />
        <Spacer direction="vertical" size={6} />
        <StatusText text={data?.status} />
      </Box>
    </Box>
  )
}
